(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(80418);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
;// CONCATENATED MODULE: ./components/Backdrop.js



var Backdrop = function() {
    var ref = (0,react.useContext)(context/* StoreContext */.x), backdrop = ref.backdrop, setBackdrop = ref.setBackdrop;
    if (backdrop) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed z-50 bg-black bg-opacity-70 w-screen inset-0 h-screen ",
        onClick: function() {
            setBackdrop(false);
        }
    });
};
/* harmony default export */ var components_Backdrop = (Backdrop);

// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/FavouritesRight.js





var FavouritesList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 88926).then(__webpack_require__.bind(__webpack_require__, 88926));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88926)
            ];
        }
    },
    ssr: false
});
var FavouritesRight = function() {
    var Close = function Close() {
        setFavouritesIsOpen(0);
    };
    var favouritesRightTitle = (0,TranslationContext/* useTranslation */.m)().favouritesRightTitle;
    var ref = (0,react.useContext)(context/* StoreContext */.x), setFavouritesIsOpen = ref.setFavouritesIsOpen, favouritesIsOpen = ref.favouritesIsOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed  flex-col flex right-0 top-0 bg-white shadow-lg w-72 rounded-sm h-screen px-3 py-5 overflow-y-auto z-50 transition-all transform-gpu " + (favouritesIsOpen ? "translate-x-0 " : "translate-x-full "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center mb-3 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "text-lg inline-block",
                        children: favouritesRightTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function(e) {
                            Close();
                        },
                        children: "x"
                    })
                ]
            }),
            favouritesIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouritesList, {}) : null
        ]
    });
};
/* harmony default export */ var components_FavouritesRight = (FavouritesRight);

// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
;// CONCATENATED MODULE: ./components/Layout.js








var Menubar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 11977).then(__webpack_require__.bind(__webpack_require__, 11977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11977)
            ];
        }
    },
    ssr: false
});
var WhatsappDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(75617)]).then(__webpack_require__.bind(__webpack_require__, 80039));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80039)
            ];
        }
    },
    ssr: false
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(31985)]).then(__webpack_require__.bind(__webpack_require__, 58114));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58114)
            ];
        }
    }
});
var Layout = function(param) {
    var ssr = param.ssr, children = param.children, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var ref = (0,react.useState)(false), isPhone = ref[0], setIsPhone = ref[1];
    var ref1 = (0,react.useContext)(context/* StoreContext */.x) || {}, setPage = ref1.setPage, setCurrentRoutingTypeId = ref1.setCurrentRoutingTypeId, currentRoutingTypeId = ref1.currentRoutingTypeId;
    (0,react.useEffect)(function() {
        setIsPhone(is_mobile_default()());
    }, []);
    (0,react.useEffect)(function() {
        setCurrentRoutingTypeId(ssr.RoutingTypeId);
        setPage(ssr.result);
    }, [
        ssr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Backdrop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FavouritesRight, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menubar, {
                ssr: ssr.result,
                RoutingTypeId: ssr.RoutingTypeId,
                isAppWebView: isAppWebView,
                deviceType: deviceType
            }),
            !isPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappDesktop, {}) : null,
            ssr.result.footer != "0" && ssr.disableHeader != true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                ssr: ssr
            })
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 71593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Blur; }
/* harmony export */ });
var Remote = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    if (width > 1920) width = 1920;
    return "".concat("https://cdn.balayivillasikirala.com.tr", "/uploads/").concat(width, "/").concat(src);
};
var Blur = function(src) {
    return "".concat("https://cdn.balayivillasikirala.com.tr", "/uploads/30/").concat(src);
};
/* harmony default export */ __webpack_exports__["Z"] = (Remote);


/***/ }),

/***/ 15594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84849);



var LoaderProductCategories = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-y-[0.875rem] gap-x-5 mb-[0.875rem]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 106,
                            count: 1
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 106,
                            count: 1
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 106,
                            count: 1
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-y-[0.875rem] gap-x-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 106,
                            count: 1
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 106,
                            count: 1
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 106,
                            count: 1
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderProductCategories);


/***/ }),

/***/ 21728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73040);



var Container = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(param, ref) {
    var children = param.children;
    var productCategoriesTitle = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .m)().productCategoriesTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "bg-brand-gray-7 py-8 hidden lg:block",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center justify-center pb-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-bold text-xl lg:text-3xl text-[#333738] mb-4",
                        children: productCategoriesTitle
                    })
                }),
                children
            ]
        })
    });
});
Container.displayName = "Container";
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 8710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73040);



var ProductDestinationsContainer = function(param) {
    var children = param.children;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .m)(), productDestinationsContainerTitle = ref.productDestinationsContainerTitle, productDestinationsContainerCaption = ref.productDestinationsContainerCaption;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-brand-gray-7 py-9 lg:hidden",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-center pb-2 flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "font-bold text-xl lg:text-3xl text-[#333738] mb-1",
                            children: productDestinationsContainerTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: productDestinationsContainerCaption
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex",
                        children: children
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductDestinationsContainer);


/***/ }),

/***/ 17601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var InfoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 49562).then(__webpack_require__.bind(__webpack_require__, 49562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49562)
            ];
        }
    }
});
var InstagramIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 81147).then(__webpack_require__.bind(__webpack_require__, 81147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81147)
            ];
        }
    }
});
var LogoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 60563).then(__webpack_require__.bind(__webpack_require__, 60563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60563)
            ];
        }
    }
});
var FacebookIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55849).then(__webpack_require__.bind(__webpack_require__, 55849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55849)
            ];
        }
    }
});
var YoutubeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 86759).then(__webpack_require__.bind(__webpack_require__, 86759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86759)
            ];
        }
    }
});
var DatepickerArrowsIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 10945).then(__webpack_require__.bind(__webpack_require__, 10945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10945)
            ];
        }
    }
});
var LocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34364).then(__webpack_require__.bind(__webpack_require__, 34364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34364)
            ];
        }
    }
});
var SearchIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 39750).then(__webpack_require__.bind(__webpack_require__, 39750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39750)
            ];
        }
    }
});
var ArrowDownIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5915).then(__webpack_require__.bind(__webpack_require__, 5915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5915)
            ];
        }
    }
});
var TimesIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 36539).then(__webpack_require__.bind(__webpack_require__, 36539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36539)
            ];
        }
    }
});
var PaymentOptionIcon1 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 57905).then(__webpack_require__.bind(__webpack_require__, 57905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57905)
            ];
        }
    }
});
var PaymentOptionIcon2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18686).then(__webpack_require__.bind(__webpack_require__, 18686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18686)
            ];
        }
    }
});
var HeartIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14119).then(__webpack_require__.bind(__webpack_require__, 14119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14119)
            ];
        }
    }
});
var AttentionIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55613).then(__webpack_require__.bind(__webpack_require__, 55613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55613)
            ];
        }
    }
});
var FaturaIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52415).then(__webpack_require__.bind(__webpack_require__, 52415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52415)
            ];
        }
    }
});
var CallIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 26006).then(__webpack_require__.bind(__webpack_require__, 26006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26006)
            ];
        }
    }
});
var WhatsappnewIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 40305).then(__webpack_require__.bind(__webpack_require__, 40305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40305)
            ];
        }
    }
});
var ReverseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 72142).then(__webpack_require__.bind(__webpack_require__, 72142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72142)
            ];
        }
    }
});
var MapIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 88450).then(__webpack_require__.bind(__webpack_require__, 88450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88450)
            ];
        }
    }
});
var Icons_new = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 793).then(__webpack_require__.bind(__webpack_require__, 793));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(793)
            ];
        }
    }
});
var Icons_new2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14973).then(__webpack_require__.bind(__webpack_require__, 14973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14973)
            ];
        }
    }
});
var Icons_new3 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38796).then(__webpack_require__.bind(__webpack_require__, 38796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38796)
            ];
        }
    }
});
var Icons_new4 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68344).then(__webpack_require__.bind(__webpack_require__, 68344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68344)
            ];
        }
    }
});
var WorkingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 73477).then(__webpack_require__.bind(__webpack_require__, 73477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73477)
            ];
        }
    }
});
var ProblemreportIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 44059).then(__webpack_require__.bind(__webpack_require__, 44059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44059)
            ];
        }
    }
});
var WheltimeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 63270).then(__webpack_require__.bind(__webpack_require__, 63270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63270)
            ];
        }
    }
});
var GancelIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 51623).then(__webpack_require__.bind(__webpack_require__, 51623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51623)
            ];
        }
    }
});
var GuestconfirmationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 21443).then(__webpack_require__.bind(__webpack_require__, 21443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21443)
            ];
        }
    }
});
var CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25194).then(__webpack_require__.bind(__webpack_require__, 25194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25194)
            ];
        }
    }
});
var VillaLocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34920).then(__webpack_require__.bind(__webpack_require__, 34920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34920)
            ];
        }
    }
});
var PlayButtonIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17686).then(__webpack_require__.bind(__webpack_require__, 17686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17686)
            ];
        }
    }
});
var DetailIncludedPriceIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 59715).then(__webpack_require__.bind(__webpack_require__, 59715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59715)
            ];
        }
    }
});
var BarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var CallCenterIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18238).then(__webpack_require__.bind(__webpack_require__, 18238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18238)
            ];
        }
    }
});
var UserIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 78822).then(__webpack_require__.bind(__webpack_require__, 78822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78822)
            ];
        }
    }
});
var ClockIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 76255).then(__webpack_require__.bind(__webpack_require__, 76255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76255)
            ];
        }
    }
});
var PaginationPrevIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var PaginationNextIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18229).then(__webpack_require__.bind(__webpack_require__, 18229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18229)
            ];
        }
    }
});
var ShareIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 91788).then(__webpack_require__.bind(__webpack_require__, 91788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91788)
            ];
        }
    }
});
var HousekeepingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 29097).then(__webpack_require__.bind(__webpack_require__, 29097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29097)
            ];
        }
    }
});
var CameraIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 22437).then(__webpack_require__.bind(__webpack_require__, 22437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22437)
            ];
        }
    }
});
var TeamIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 42908).then(__webpack_require__.bind(__webpack_require__, 42908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42908)
            ];
        }
    }
});
var CommentIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 97088).then(__webpack_require__.bind(__webpack_require__, 97088));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97088)
            ];
        }
    }
});
var WalletIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18688).then(__webpack_require__.bind(__webpack_require__, 18688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18688)
            ];
        }
    }
});
var UserodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18024).then(__webpack_require__.bind(__webpack_require__, 18024));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18024)
            ];
        }
    }
});
var MailodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 37822).then(__webpack_require__.bind(__webpack_require__, 37822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37822)
            ];
        }
    }
});
var PhoneodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 28892).then(__webpack_require__.bind(__webpack_require__, 28892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28892)
            ];
        }
    }
});
var EditodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 35623).then(__webpack_require__.bind(__webpack_require__, 35623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35623)
            ];
        }
    }
});
var LockodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9748).then(__webpack_require__.bind(__webpack_require__, 9748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9748)
            ];
        }
    }
});
var LocationPinIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 80707).then(__webpack_require__.bind(__webpack_require__, 80707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80707)
            ];
        }
    }
});
var StarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 99484).then(__webpack_require__.bind(__webpack_require__, 99484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99484)
            ];
        }
    }
});
var KtbIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9842).then(__webpack_require__.bind(__webpack_require__, 9842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9842)
            ];
        }
    }
});
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var icons = {
        info: InfoIcon,
        logo: LogoIcon,
        instagram: InstagramIcon,
        facebook: FacebookIcon,
        youtube: YoutubeIcon,
        datepickerArrows: DatepickerArrowsIcon,
        location: LocationIcon,
        search: SearchIcon,
        ArrowDown: ArrowDownIcon,
        Times: TimesIcon,
        PaymentOption1: PaymentOptionIcon1,
        PaymentOption2: PaymentOptionIcon2,
        Heart: HeartIcon,
        attention: AttentionIcon,
        fatura: FaturaIcon,
        call: CallIcon,
        whatsappnew: WhatsappnewIcon,
        reverse: ReverseIcon,
        map: MapIcon,
        newIcon1: Icons_new,
        newIcon2: Icons_new2,
        newIcon3: Icons_new3,
        newIcon4: Icons_new4,
        working: WorkingIcon,
        villaLocation: VillaLocationIcon,
        PlayButton: PlayButtonIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        Bar: BarIcon,
        CallCenter: CallCenterIcon,
        problemreport: ProblemreportIcon,
        wheltime: WheltimeIcon,
        gancel: GancelIcon,
        guestconfirmation: GuestconfirmationIcon,
        close: CloseIcon,
        user: UserIcon,
        clock: ClockIcon,
        PaginationPrev: PaginationPrevIcon,
        PaginationNext: PaginationNextIcon,
        Share: ShareIcon,
        Wallet: WalletIcon,
        Comment: CommentIcon,
        Camera: CameraIcon,
        Housekeeping: HousekeepingIcon,
        Team: TeamIcon,
        userodeme: UserodemeIcon,
        mailodeme: MailodemeIcon,
        phoneodeme: PhoneodemeIcon,
        editodeme: EditodemeIcon,
        lockodeme: LockodemeIcon,
        LocationPin: LocationPinIcon,
        Star: StarIcon,
        ktb: KtbIcon
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        size: size,
        className: className
    });
};



/***/ }),

/***/ 80418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Meta; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Loaders/LoaderProductCategories.js
var LoaderProductCategories = __webpack_require__(15594);
// EXTERNAL MODULE: ./components/ProductCategories/Container.js
var Container = __webpack_require__(21728);
// EXTERNAL MODULE: ./components/ProductDestinations/ProductDestinationsContainer.js
var ProductDestinationsContainer = __webpack_require__(8710);
// EXTERNAL MODULE: ./components/Layout.js + 2 modules
var Layout = __webpack_require__(48007);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/Loaders/LoaderStories.js



var LoadingComp = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center mr-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[4.25rem] h-[4.25rem] flex items-center justify-center rounded-full ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        containerClassName: "w-[4.25rem] h-[4.25rem] ",
                        className: "h-full",
                        circle: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col text-center font-bold text-[0.688rem] mt-1 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        containerClassName: "",
                        count: 2,
                        height: 8
                    })
                })
            ]
        })
    });
};
var LoaderStories = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block lg:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-x-auto flex flex-nowrap relative pb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComp, {})
                ]
            })
        })
    });
};
/* harmony default export */ var Loaders_LoaderStories = (LoaderStories);

// EXTERNAL MODULE: ./components/Index/SearchBox.module.css
var SearchBox_module = __webpack_require__(2831);
var SearchBox_module_default = /*#__PURE__*/__webpack_require__.n(SearchBox_module);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
;// CONCATENATED MODULE: ./node_modules/react-type-animation/dist/esm/index.es.js
function a(e,t,n,r){return new(n||(n=Promise))((function(o,a){function u(e){try{i(r.next(e))}catch(e){a(e)}}function c(e){try{i(r.throw(e))}catch(e){a(e)}}function i(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(u,c)}i((r=r.apply(e,t||[])).next())}))}function u(e,t){var n,r,o,a,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return a={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function c(a){return function(c){return function(a){if(n)throw new TypeError("Generator is already executing.");for(;u;)try{if(n=1,r&&(o=2&a[0]?r.return:a[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,a[1])).done)return o;switch(r=0,o&&(a=[2&a[0],o.value]),a[0]){case 0:case 1:o=a;break;case 4:return u.label++,{value:a[1],done:!1};case 5:u.label++,r=a[1],a=[0];continue;case 7:a=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==a[0]&&2!==a[0])){u=0;continue}if(3===a[0]&&(!o||a[1]>o[0]&&a[1]<o[3])){u.label=a[1];break}if(6===a[0]&&u.label<o[1]){u.label=o[1],o=a;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(a);break}o[2]&&u.ops.pop(),u.trys.pop();continue}a=t.call(e,u)}catch(e){a=[6,e],r=0}finally{n=o=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,c])}}}function c(e){var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&"number"==typeof e.length)return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function i(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var r,o,a=n.call(e),u=[];try{for(;(void 0===t||t-- >0)&&!(r=a.next()).done;)u.push(r.value)}catch(e){o={error:e}}finally{try{r&&!r.done&&(n=a.return)&&n.call(a)}finally{if(o)throw o.error}}return u}function l(e,t,n){if(n||2===arguments.length)for(var r,o=0,a=t.length;o<a;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))}function s(e,t,n,r){for(var o=[],s=4;s<arguments.length;s++)o[s-4]=arguments[s];return a(this,void 0,void 0,(function(){var a,s,h,p,y,v;return u(this,(function(u){switch(u.label){case 0:u.trys.push([0,12,13,14]),a=c(o),s=a.next(),u.label=1;case 1:if(s.done)return[3,11];switch(h=s.value,typeof h){case"string":return[3,2];case"number":return[3,4];case"function":return[3,6]}return[3,8];case 2:return[4,f(e,h,t,n,r)];case 3:return u.sent(),[3,10];case 4:return[4,d(h)];case 5:return u.sent(),[3,10];case 6:return[4,h.apply(void 0,l([e,t,n,r],i(o),!1))];case 7:return u.sent(),[3,10];case 8:return[4,h];case 9:u.sent(),u.label=10;case 10:return s=a.next(),[3,1];case 11:return[3,14];case 12:return p=u.sent(),y={error:p},[3,14];case 13:try{s&&!s.done&&(v=a.return)&&v.call(a)}finally{if(y)throw y.error}return[7];case 14:return[2]}}))}))}function f(e,t,n,r,o){return a(this,void 0,void 0,(function(){var a;return u(this,(function(u){switch(u.label){case 0:return a=function(e,t){var n=i(t).slice(0);return l(l([],i(e),!1),[NaN],!1).findIndex((function(e,t){return n[t]!==e}))}(e.textContent,t),[4,h(e,l(l([],i(y(e.textContent,a)),!1),i(p(t,a)),!1),n,r,o)];case 1:return u.sent(),[2]}}))}))}function d(e){return a(this,void 0,void 0,(function(){return u(this,(function(t){switch(t.label){case 0:return[4,new Promise((function(t){return setTimeout(t,e)}))];case 1:return t.sent(),[2]}}))}))}function h(e,t,n,r,o){return a(this,void 0,void 0,(function(){var a,i,l,s,f,h,p,y,v,b,m,w;return u(this,(function(x){switch(x.label){case 0:if(a=t,o){for(i=0,l=1;l<t.length;l++)if(s=t[l-1],(f=t[l]).length>s.length||""===f){i=l;break}a=t.slice(i,t.length)}x.label=1;case 1:x.trys.push([1,6,7,8]),h=c(function(e){var t,n,r,o,a,i,l;return u(this,(function(s){switch(s.label){case 0:t=function(e){return u(this,(function(t){switch(t.label){case 0:return[4,{op:function(t){return requestAnimationFrame((function(){return t.textContent=e}))},opCode:function(t){return""===e||t.textContent.length>e.length?"DELETE":"WRITING"}}];case 1:return t.sent(),[2]}}))},s.label=1;case 1:s.trys.push([1,6,7,8]),n=c(e),r=n.next(),s.label=2;case 2:return r.done?[3,5]:(o=r.value,[5,t(o)]);case 3:s.sent(),s.label=4;case 4:return r=n.next(),[3,2];case 5:return[3,8];case 6:return a=s.sent(),i={error:a},[3,8];case 7:try{r&&!r.done&&(l=n.return)&&l.call(n)}finally{if(i)throw i.error}return[7];case 8:return[2]}}))}(a)),p=h.next(),x.label=2;case 2:return p.done?[3,5]:(y=p.value,v="WRITING"===y.opCode(e)?n+n*(Math.random()-.5):r+r*(Math.random()-.5),y.op(e),[4,d(v)]);case 3:x.sent(),x.label=4;case 4:return p=h.next(),[3,2];case 5:return[3,8];case 6:return b=x.sent(),m={error:b},[3,8];case 7:try{p&&!p.done&&(w=h.return)&&w.call(h)}finally{if(m)throw m.error}return[7];case 8:return[2]}}))}))}function p(e,t,n){var r=i(e).slice(0);return void 0===t&&(t=0),void 0===n&&(n=r.length),u(this,(function(e){switch(e.label){case 0:return t<n?[4,r.slice(0,++t).join("")]:[3,2];case 1:return e.sent(),[3,0];case 2:return[2]}}))}function y(e,t,n){var r=i(e).slice(0);return void 0===t&&(t=0),void 0===n&&(n=r.length),u(this,(function(e){switch(e.label){case 0:return n>t?[4,r.slice(0,--n).join("")]:[3,2];case 1:return e.sent(),[3,0];case 2:return[2]}}))}var v="index-module_type__E-SaG";!function(e,t){void 0===t&&(t={});var n=t.insertAt;if(e&&"undefined"!=typeof document){var r=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style");o.type="text/css","top"===n&&r.firstChild?r.insertBefore(o,r.firstChild):r.appendChild(o),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(document.createTextNode(e))}}(".index-module_type__E-SaG::after {\n  content: '|';\n  animation: index-module_cursor__PQg0P 1.1s infinite step-start;\n}\n\n@keyframes index-module_cursor__PQg0P {\n  50% {\n    opacity: 0;\n  }\n}\n");var b=(0,react.memo)((function(o){var a=o.sequence,u=o.repeat,c=o.className,f=o.speed,d=void 0===f?40:f,h=o.deletionSpeed,p=o.omitDeletionAnimation,y=void 0!==p&&p,b=o.wrapper,m=void 0===b?"div":b,w=o.cursor,x=void 0===w||w,g=o.style;d=Math.abs(d-100),h=h?Math.abs(h-100):d;var S,_,C,E,T,N,A=(0,react.useRef)(null),k=v;S=c&&c.length>0?x?"".concat(k," ").concat(c):c:x?k:"",_=(0,react.useRef)((function(){return u===1/0?s.apply(void 0,l(l([A.current,d,h,y],i(a),!1),[s],!1)):"number"==typeof u?s.apply(void 0,l([A.current,d,h,y],i(Array(1+u).fill(a).flat()),!1)):s.apply(void 0,l([A.current,d,h,y],i(a),!1)),function(){A.current}})),C=(0,react.useRef)(),E=(0,react.useRef)(!1),T=(0,react.useRef)(!1),N=i((0,react.useState)(0),2)[1],E.current&&(T.current=!0),(0,react.useEffect)((function(){return E.current||(C.current=_.current(),E.current=!0),N((function(e){return e+1})),function(){T.current&&C.current&&C.current()}}),[]);var P=m;return react.createElement(P,{style:g,className:S,ref:A})}),(function(e,t){return!0}));
//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Index/SliderCaption.js






var SliderCaption = function() {
    var ref = (0,TranslationContext/* useTranslation */.m)(), forYou = ref.forYou, mobileSliderCaption1 = ref.mobileSliderCaption1, mobileSliderCaption1_balayi = ref.mobileSliderCaption1_balayi, mobileSliderCaption2 = ref.mobileSliderCaption2, mobileSliderCaption3 = ref.mobileSliderCaption3, mobileSliderCaption3_balayi = ref.mobileSliderCaption3_balayi, sliderCaptionDefault = ref.sliderCaptionDefault;
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), isLoaded = ref2[0], setIsLoaded = ref2[1];
    var ref3 = (0,react.useState)([]), items = ref3[0], setItems = ref3[1];
    (0,react.useEffect)(function() {
        (0,api/* GetSliderCaption */.Pu)().then(function(r) {
            setItems(r.data);
            setIsLoaded(true);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:mt-10 2xl:mt-10 text-black lg:text-brand-black text-center xl:text-left xl:w-full order-2 lg:order-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center mt-3 min-h-[82px] lg:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-full text-2xl font-bold",
                        children: forYou
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(b, {
                        sequence: [
                             true ? mobileSliderCaption1_balayi : 0,
                            1500,
                            mobileSliderCaption2,
                            1500,
                             true ? mobileSliderCaption3_balayi : 0,
                            1500
                        ],
                        wrapper: "div",
                        cursor: false,
                        deletionSpeed: 100,
                        repeat: Infinity,
                        className: "text-xl ml:text-2xl"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        count: 10
                    })
                }) : !isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-3/5 hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                height: 30
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full lg:w-4/5 mt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                height: 110,
                                className: "mb-2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-3/5 hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                count: 2
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base font-bold leading-8 lg:leading-none lg:block lg:text-lg xl:text-25 lg:font-normal hidden",
                            children: items[0].aciklama2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "lg:block text-2xl lg:text-6xl xl:text-65 leading-none font-bold w-7/12 lg:w-full lg:pr-10 2xl:pr-44 mt-2 hidden",
                            dangerouslySetInnerHTML: {
                                __html: items[0].aciklama.replace("{", "<span class='text-orange lg:text-brand-blue'>").replace("}", "</span>")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                            className: "hidden lg:block text-tiny xl:text-15 font-normal text-brand-black xl:opacity-50 leading-5 xl:pr-44 mt-6",
                            children: items[0].aciklama3
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Index_SliderCaption = (SliderCaption);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
;// CONCATENATED MODULE: ./components/Index/Social.js




var Social = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden lg:flex xl:flex-col w-24 self-end items-center gap-y-1 gap-x-4 mt-2 xl:mt-7 min-h-[130px]",
        children: [
            data.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: data.instagram,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: "Balayi Villası Kirala" + " Instagram",
                    target: "_blank",
                    rel: "nofollow",
                    className: " py-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "instagram"
                    })
                })
            }),
            data.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: data.facebook,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: "Balayi Villası Kirala" + " Facebook",
                    target: "_blank",
                    rel: "nofollow",
                    className: " py-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "facebook"
                    })
                })
            }),
            data.youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: data.youtube,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: "Balayi Villası Kirala" + " Youtube",
                    target: "_blank",
                    rel: "nofollow",
                    className: " py-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "youtube"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Index_Social = (Social);

;// CONCATENATED MODULE: ./components/Index/CallCenter.js




var CallCenter = function(param) {
    var phone = param.phone;
    var callCenterName = (0,TranslationContext/* useTranslation */.m)().callCenterName;
    var last = phone.substr(phone.length - 13);
    var bold = phone.replace(last, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden items-center mt-10 lg:flex order-last",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-call-color",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "CallCenter"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col ml-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-brand-black opacity-60 font-medium text-xs tracking-0",
                        children: callCenterName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-medium text-base text-brand-black tracking-11",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: bold
                            }),
                            last
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Index_CallCenter = (CallCenter);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./components/Index/AllVillasCta.module.css
var AllVillasCta_module = __webpack_require__(40647);
var AllVillasCta_module_default = /*#__PURE__*/__webpack_require__.n(AllVillasCta_module);
;// CONCATENATED MODULE: ./components/Index/AllVillasCta.js







// Tarih seçmeden tüm villalara göz atmak isteyenler için.
// variant="strip": masaüstünde arama kutusunun altına yapışık şerit
// variant="card": mobil / tablet için tek başına kart
var AllVillasCta = function(param) {
    var _destinations = param.destinations, destinations = _destinations === void 0 ? [] : _destinations, _variant = param.variant, variant = _variant === void 0 ? "card" : _variant, _className = param.className, className = _className === void 0 ? "" : _className;
    var ref = (0,TranslationContext/* useTranslation */.m)(), allVillasCta = ref.allVillasCta, allVillasCtaStrip = ref.allVillasCtaStrip, allVillasCtaRest = ref.allVillasCtaRest, allVillasCtaSub = ref.allVillasCtaSub;
    var isStrip = variant === "strip";
    var photos = destinations.filter(function(d) {
        return d === null || d === void 0 ? void 0 : d.resim;
    }).slice(0, 3);
    var names = destinations.slice(0, 3).map(function(d) {
        return d.baslik;
    }).join(", ");
    var subText = names ? names + " " + allVillasCtaRest : allVillasCtaSub;
    var stack = photos.length === 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (AllVillasCta_module_default()).Stack + (isStrip ? " " + (AllVillasCta_module_default()).StackSm : ""),
        "aria-hidden": "true",
        children: photos.map(function(d) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (AllVillasCta_module_default()).Photo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: d.resim,
                    loader: LoaderRemote/* default */.Z,
                    width: isStrip ? 44 : 56,
                    height: isStrip ? 44 : 56,
                    objectFit: "cover",
                    alt: ""
                })
            }, d.id);
        })
    }) : null;
    var arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "relative flex items-center justify-center text-white rounded-full shrink-0 bg-brand-color-secondary " + (isStrip ? "w-10 h-10 " : "w-11 h-11 ") + (AllVillasCta_module_default()).Go,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: "w-5 h-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5 12h14"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m13 6 6 6-6 6"
                })
            ]
        })
    });
    if (isStrip) return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/kiralik-villalar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            title: allVillasCta,
            className: "group relative items-center gap-4 py-2.5 pl-4 pr-5 border-t border-[#d9eef0] bg-[#effafa] hover:bg-[#e2f6f6] shadow-search transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary " + (AllVillasCta_module_default()).Card + " " + className,
            children: [
                stack,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex flex-col min-w-0 mr-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-15 font-bold leading-tight text-brand-black",
                            children: allVillasCtaStrip
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mt-0.5 text-xs font-medium text-brand-black opacity-60",
                            children: subText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm font-bold text-brand-color-secondary whitespace-nowrap",
                    children: allVillasCta
                }),
                arrow
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/kiralik-villalar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            title: allVillasCta,
            className: "group flex items-center gap-4 py-3 pl-3 pr-4 bg-white rounded-lg shadow-lg ring-1 ring-black/5 transition-shadow hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-primary " + (AllVillasCta_module_default()).Card + " " + className,
            children: [
                stack,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex flex-col min-w-0 mr-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base font-bold leading-tight text-brand-black",
                            children: allVillasCta
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mt-0.5 text-xs font-medium leading-snug text-brand-black opacity-60",
                            children: subText
                        })
                    ]
                }),
                arrow
            ]
        })
    });
};
/* harmony default export */ var Index_AllVillasCta = (AllVillasCta);

// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
;// CONCATENATED MODULE: ./components/Index/SearchboxWrapper.js








var SliderForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(42298), __webpack_require__.e(76964), __webpack_require__.e(57002), __webpack_require__.e(21669)]).then(__webpack_require__.bind(__webpack_require__, 97176));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97176)
            ];
        }
    },
    ssr: false
});
var SearchBoxRight = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 80291).then(__webpack_require__.bind(__webpack_require__, 80291));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80291)
            ];
        }
    },
    ssr: false
});
var SearchboxWrapper = function(param) {
    var ssr = param.ssr;
    var isPhone = is_mobile_default()();
    var destinations = ssr.result.ProductDestinations || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container flex flex-col-reverse xl:flex-row lg:bg-header-gra xl:bg-none overflow-hidden lg:overflow-visible",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full xl:w-7/12 2xl:w-3/5 lg:-mt-24 lg:pt-24 flex-col ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_Social, {
                        data: ssr.result.social
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_SliderCaption, {}),
                    !isPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderForm, {
                        className: "hidden lg:flex"
                    }) : null,
                    !isPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_AllVillasCta, {
                        variant: "strip",
                        destinations: destinations,
                        className: "hidden order-1 lg:flex xl:w-[calc(100%_+_9rem)]"
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_CallCenter, {
                        phone: ssr.result.rez_tel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_AllVillasCta, {
                        destinations: destinations,
                        className: "order-last mt-6 mb-3 lg:hidden"
                    })
                ]
            }),
            !isPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoxRight, {}) : null
        ]
    });
};
/* harmony default export */ var Index_SearchboxWrapper = (SearchboxWrapper);

// EXTERNAL MODULE: ./components/Index/InformationBanner.module.css
var InformationBanner_module = __webpack_require__(14232);
var InformationBanner_module_default = /*#__PURE__*/__webpack_require__.n(InformationBanner_module);
;// CONCATENATED MODULE: ./components/Index/InformationBanner.js






var InformationBanner = function(param) {
    var ssr = param.ssr;
    var ref = (0,TranslationContext/* useTranslation */.m)(), informationBanner1Title = ref.informationBanner1Title, informationBanner2Title_balayi = ref.informationBanner2Title_balayi, informationBanner1SubTitle = ref.informationBanner1SubTitle, informationBanner1ButtonText = ref.informationBanner1ButtonText, documentNo = ref.documentNo, informationBanner2Title = ref.informationBanner2Title, informationBanner2ButtonText = ref.informationBanner2ButtonText, informationBanner3Title = ref.informationBanner3Title, informationBanner3ButtonText = ref.informationBanner3ButtonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container " + (InformationBanner_module_default()).InformationBanner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:mt-5 lg:mt-10 flex gap-x-4 overflow-x-scroll snap-x snap-mandatory pb-10 xl:overflow-x-visible",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-product-type-color h-20 lg:h-28 rounded-lg overflow-hidden relative z-[1] lg:flex-[calc(50%-8px)] xl:flex-[calc(33%-8px)] flex-[0_0_85%] snap-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full ".concat((InformationBanner_module_default()).MaskContentImage),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center h-full pr-1 ml:pr-",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center pl-1 pr-1 ml:pl-8 ml:pr-8 h-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative w-16 h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/icons/informationBanner1.svg",
                                            layout: "fill",
                                            alt: ""
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "xl:text-[1.188rem] text-15 font-bold text-white",
                                            children: informationBanner1Title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "xl:text-[1.188rem] text-15 font-bold text-white pb-2",
                                            children: informationBanner1SubTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: ssr.result.Banner1.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                title: ssr.result.Banner1.title,
                                                className: "text-[0.875rem] font-semibold text-white opacity-70 border-b leading-[1.188rem]",
                                                children: informationBanner1ButtonText
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " h-20 lg:h-28 rounded-lg overflow-hidden relative z-[1] lg:flex-[calc(50%-8px)] xl:flex-[calc(33%-8px)] flex-[0_0_85%] snap-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-information-color h-20 lg:h-28 lg:w-auto overflow-hidden rounded-lg relative z-[1]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-full ".concat((InformationBanner_module_default()).MaskContentImage),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center h-full pr-1 ml:pr-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center ml-2 ml:pl-11 pr-2 ml:pr-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative w-20 h-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/icons/informationBanner2.svg",
                                                    layout: "fill",
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col mt-1 text-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-[#6b6c6c] text-13",
                                                        children: documentNo
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-[#ff0000] text-13",
                                                        children: "14264"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "xl:text-[1.188rem] text-15 font-bold text-white pb-2",
                                                children:  true ? informationBanner2Title_balayi : 0
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://www.tursab.org.tr/tr/ddsv",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-[0.875rem] font-semibold text-white opacity-70 border-b leading-[1.188rem]",
                                                        children: informationBanner2ButtonText
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-information-color2 h-20 lg:h-28 rounded-lg overflow-hidden relative z-[1] lg:flex-[calc(50%-8px)] xl:flex-[calc(33%-8px)] flex-[0_0_85%] snap-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full ".concat((InformationBanner_module_default()).MaskContentImage),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center h-full pr-2 ml:pr-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col items-center pl-2 ml:pl-11 pr-2 ml:pr-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative w-16 h-16",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/icons/informationBanner3.svg",
                                            layout: "fill",
                                            alt: ""
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "xl:text-[1.188rem] text-15 font-bold text-white pb-2",
                                            children: informationBanner3Title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: ssr.result.Banner3.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                title: ssr.result.Banner3.title,
                                                className: "text-[0.875rem] font-semibold text-white opacity-70 border-b leading-[1.188rem]",
                                                children: informationBanner3ButtonText
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Index_InformationBanner = (InformationBanner);

;// CONCATENATED MODULE: ./components/Index/SearchBox.js




// import dynamic from "next/dynamic";
// import LoaderInformationBanner from "../Loaders/LoaderInformationBanner";

// const InformationBanner = dynamic(() => import("./InformationBanner"), {
//   loading: () => <LoaderInformationBanner />,
// });

var SearchBox = function(param) {
    var ssr = param.ssr;
    var searchBoxTitle = (0,TranslationContext/* useTranslation */.m)().searchBoxTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full bg-no-repeat lg:block lg:-mt-24 lg:pt-24 lg:h-auto pb-5  " + (SearchBox_module_default()).BgSearchBoxPattern,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_SearchboxWrapper, {
                ssr: ssr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_InformationBanner, {
                ssr: ssr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "bg-brand-color-secondary inline-block rounded-md w-full text-white py-2 px-4",
                    children: searchBoxTitle
                })
            })
        ]
    });
};
/* harmony default export */ var Index_SearchBox = (SearchBox);

// EXTERNAL MODULE: ./themes/themes.js
var themes = __webpack_require__(89507);
;// CONCATENATED MODULE: ./components/Pages/Home.js






//const Structural = dynamic(() => import("../Structural"));




var Stories = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 58219).then(__webpack_require__.bind(__webpack_require__, 58219));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58219)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loaders_LoaderStories, {});
    }
});
var ProductDestinations = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 58032).then(__webpack_require__.bind(__webpack_require__, 58032));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58032)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDestinationsContainer/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 80,
                    count: 1,
                    containerClassName: "flex-33 p-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 80,
                    count: 1,
                    containerClassName: "flex-33 p-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 80,
                    count: 1,
                    containerClassName: "flex-33 p-2"
                })
            ]
        });
    }
});
var ProductCategories = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(24366), __webpack_require__.e(40097)]).then(__webpack_require__.bind(__webpack_require__, 91540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91540)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderProductCategories/* default */.Z, {})
        });
    }
});
var Products = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 97713).then(__webpack_require__.bind(__webpack_require__, 97713));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97713)
            ];
        }
    }
});
var LastMinute = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 67597).then(__webpack_require__.bind(__webpack_require__, 67597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67597)
            ];
        }
    }
});
var Review = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(24366), __webpack_require__.e(46071)]).then(__webpack_require__.bind(__webpack_require__, 53557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53557)
            ];
        }
    }
});
var ShortTerms = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 79530).then(__webpack_require__.bind(__webpack_require__, 79530));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79530)
            ];
        }
    }
});
var Faq = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 82814).then(__webpack_require__.bind(__webpack_require__, 82814));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82814)
            ];
        }
    }
});
var FooterBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 44562).then(__webpack_require__.bind(__webpack_require__, 44562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44562)
            ];
        }
    }
});
var LastMinuteModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60035), __webpack_require__.e(1950)]).then(__webpack_require__.bind(__webpack_require__, 1950));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1950)
            ];
        }
    }
});
var Home = function(param) {
    var ssr = param.ssr;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        ssr: ssr,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stories, {
                data: ssr.result.Story
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_SearchBox, {
                ssr: ssr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDestinations, {
                data: ssr.result.ProductDestinations
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategories, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {
                HomeContent: ssr.result.HomeContent,
                all: ssr.result.All,
                deviceType: ssr.deviceType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMinute, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortTerms, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Review, {
                data: ssr.result.static.GetOffer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq, {
                data: ssr.result.faq,
                isHome: "1"
            }),
            themes/* default.FooterBanner */.Z.FooterBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBanner, {
                currentRoutingTypeId: ssr.RoutingTypeId
            }),
            ssr.result.modal && /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMinuteModal, {
                page: ssr.result.modal
            })
        ]
    });
};
/* harmony default export */ var Pages_Home = (Home);

;// CONCATENATED MODULE: ./pages/index.js




var __N_SSP = true;
function Meta(param) {
    var data = param.data, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeComp, {
        fallback: data,
        isAppWebView: isAppWebView,
        deviceType: deviceType
    });
};
var HomeComp = function(param) {
    var fallback = param.fallback, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var data = fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: data.result.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: data.result.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: data.result.keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "https://www.balayivillasikirala.com.tr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "https://www.balayivillasikirala.com.tr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: data.result.canonical
                    }),
                     true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon2.ico"
                    }) : /*#__PURE__*/ 0,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    (data === null || data === void 0 ? void 0 : data.result) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: data.result.canonical
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:type",
                                content: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: data.result.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: data.result.description
                            }),
                            data.result.resim && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://cdn.balayivillasikirala.com.tr" + "/uploads/" + data.result.resim
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:domain",
                                content: "https://www.balayivillasikirala.com.tr"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:url",
                                content: data.result.canonical
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: data.result.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: data.result.description
                            }),
                            data.result.resim && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://cdn.balayivillasikirala.com.tr" + "/uploads/" + data.result.resim
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pages_Home, {
                ssr: data
            })
        ]
    });
};


/***/ }),

/***/ 40647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Stack":"AllVillasCta_Stack__gtjoC","StackSm":"AllVillasCta_StackSm__kMyVR","Photo":"AllVillasCta_Photo__XDTcn","fanIn":"AllVillasCta_fanIn__Aj_3L","Card":"AllVillasCta_Card__Vr_B5","Go":"AllVillasCta_Go__K0SHt","ring":"AllVillasCta_ring__zuVow"};

/***/ }),

/***/ 14232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MaskContentImage":"InformationBanner_MaskContentImage__kw1qM","InformationBanner":"InformationBanner_InformationBanner__60Xfg"};

/***/ }),

/***/ 2831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BgSearchBoxPattern":"SearchBox_BgSearchBoxPattern__MEGF2","BgSearchBox":"SearchBox_BgSearchBox__SVBdF","SearchBoxRightImg":"SearchBox_SearchBoxRightImg__8eEnF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [63755,50174,9012,49774,92888,40179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);